export default "__VITE_ASSET__98608481__"